import React, { Component, useRef } from "react";
import {
  Row,
  Col,
  Alert,
  Button,
  Container,
  FormGroup,
  Label,
} from "reactstrap";
import { connect, useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  forgetUser,
  clearStore,
  resetPasswordForgot,
} from "../../store/actions";
import logodark from "../../assets/images/logo-main.jpg";
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import Visibility from "@material-ui/icons/Visibility";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Input from "@material-ui/core/Input";
import { OutlinedInput } from "@material-ui/core";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useLocation } from "react-router-dom";

const PasswordResetPage = () => {
  const location = useLocation();
  const { state } = location;
  let email;
  if (state && state.email) {
    email = state.email;
    // Do something with the passed email value
    // console.log("Received Email:", email);
  }
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  // const [verificationCode, setVerificationCode] = useState("");
  const [verificationCode, setVerificationCode] = useState(['', '', '', '', '', '']);
  const verificationCodeRefs = useRef([]);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [passwordError1, setPasswordError1] = useState(false);
  const [passwordErrorBoth, setPasswordErrorBoth] = useState(false);
  const [detailedErr, setDetailedErr] = useState("");
  const [submit, setSubmit] = useState(false);
  const [verificationCodeEntered, setVerificationCodeEntered] = useState(false);
  const reset = useSelector((state) => {
    return state.forgetPassword;
  });
  var success = false;
  const { loading, resetSuccess, resetError } = reset;
  // const regex = /^(?=.[a-z])(?=.[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
  // const regex = /^(?=.\d)(?=.[a-z])(?=.[A-Z])[0-9a-zA-Z!@#$%^&?]{8,}$/;
  const regex = /^(?=.\d)(?=.[a-z])(?=.[A-Z])[0-9a-zA-Z!@#$%^&?]{8,}$/;
  const dispatch = useDispatch();
  //reset error in here

  // function handleSubmit() {
  //   // dispatch(resetPasswordForgot({ password: password1, token: token.token }));
  // }

  // function handleChangePassword(){
  //     setPassword1(password)
  // }
  function handleClickShowPassword1() {
    setShowPassword1(!showPassword1);
  }
  function handleClickShowPassword2() {
    setShowPassword2(!showPassword2);
  }
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // const handleChange = (index, event) => {
  //   const updatedVerificationCode = [...verificationCode];
  //   updatedVerificationCode[index] = event.target.value;
  //   setVerificationCode(updatedVerificationCode);
  // };

  const handleDigitChange = (index, event) => {
    const { value } = event.target;

    if (value.length <= 1) {
      const updatedVerificationCode = [...verificationCode];
      updatedVerificationCode[index] = value;
      setVerificationCode(updatedVerificationCode);

      if (
        value.length === 1 &&
        index < verificationCodeRefs.current.length - 1
      ) {
        verificationCodeRefs.current[index + 1].focus();
      }
    }
  };

  // console.log("Email = ", email);
  useEffect(() => {
    setSubmit(false);
    if (password1 != "") {
      if (!regex.test(password1)) {
        setPasswordError1(true);
        setDetailedErr(
          "Password must contain 8 or more characters and contain at least 1 Uppercase, 1 Lowercase, and 1 Number"
        );
      } else if (password1 != password2) {
        setPasswordError1(true);
        setDetailedErr("Passwords don't match!");
      } else {
        setPasswordError1(false);
      }
    }
  }, [password1]);
  useEffect(() => {
    setSubmit(false);
    if (password2 != "") {
      if (password1 != password2) {
        setPasswordError1(true);
        setDetailedErr("Passwords don't match!");
      } else {
        setPasswordError1(false);
        setSubmit(true);
      }
    }
  }, [password2]);

  useEffect(() => {
    // console.log("verificationCode=", verificationCode);
    const isEntered = verificationCode.every((digit) => digit.trim() !== "");
    // console.log("isEntered: " + isEntered);
    setVerificationCodeEntered(isEntered);
  }, [verificationCode]);

    function handleSubmit() {
      const newUser = {
        password: password1,
        verificationcode: JSON.stringify(verificationCode).replace(/[^0-9]/g, ''),
        username: email,
      };
      console.log("New User :: ", newUser);
      console.log(
        "Handle Submit :: ",
        password1,
        "verification :: ",
        verificationCode,
        "username :: ",
        email
      );
      dispatch(resetPasswordForgot(newUser));
    }


  useEffect(() => {
    if (resetSuccess) {
      success = true;
      clearStore();
    } else {
      success = false;
    }
  }, [resetSuccess]);

  useEffect(() => {
    setPassword1("");
    setPassword2("");
    setDetailedErr(resetError);
    console.log("reseterr", resetError);
  }, [resetError]);

  if (resetSuccess) {
    return (
      <Container fluid className="p-0">
        <Row className="no-gutters">
          <Col lg={5}>
            <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div className="w-100">
                <Row className="justify-content-center">
                  <Col lg={9}>
                    <div>
                      <div className="text-center">
                        <div>
                          <Link to="/" className="logo">
                            <img src={logodark} height="60" alt="logo" />
                          </Link>
                        </div>
                        <h4 className="font-size-18 mt-5"></h4>
                        <Alert color="success" className="mt-4">
                          Password Changed Successfully!
                        </Alert>
                      </div>
                      <div className="mt-5 text-center">
                        <p>
                          Return to{" "}
                          <Link
                            to="/login"
                            className="font-weight-medium text-primary"
                          >
                            {" "}
                            Login Page{" "}
                          </Link>{" "}
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col lg={7}>
            <div className="authentication-bg">
              {/* bg-overlay */}
              <div className=""></div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  } else {
    return (
      <Container fluid className="p-0">
        <Row className="no-gutters">
          <Col lg={5}>
            <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div className="w-100">
                <Row className="justify-content-center">
                  <Col lg={9}>
                    <div>
                      <div className="text-center">
                        <div>
                          <Link to="/" className="logo">
                            <img src={logodark} height="60" alt="logo" />
                          </Link>
                        </div>
                        <h4 className="font-size-18 mt-5"></h4>
                        <p className="text-muted">
                          Reset your password to Demo Register Application!
                        </p>
                      </div>

                      <div>
                        <div className="mt-4 text-center">
                          <p className="text-muted">
                            Enter verification code that you received on your
                            email account!
                          </p>
                          <div className="verification-form">
                            {[0, 1, 2, 3, 4, 5].map((index) => (
                              <TextField
                                key={index}
                                type="number"
                                inputRef={(ref) =>
                                  (verificationCodeRefs.current[index] = ref)
                                }
                                // label={`Digit ${index + 1}`}
                                variant="outlined"
                                inputProps={{
                                  maxLength: 1,
                                  className: "verification-digit-input",
                                }}
                                value={verificationCode[index]}
                                onChange={(event) =>
                                  handleDigitChange(index, event)
                                }
                              />
                            ))}
                          </div>
                          {/* <InputLabel className="text-muted">
                            <p className="text-muted">Verification Code</p>
                          </InputLabel>
                          <Input
                            type="text"
                            value={verificationCode}
                            onChange={(e) =>
                              setVerificationCode(e.target.value)
                            }
                          /> */}
                        </div>

                        <div className="mt-4 text-center">
                          <InputLabel className="text-muted">
                            <p className="text-muted">Enter password</p>
                          </InputLabel>
                          {/* <Input */}
                          <OutlinedInput
                            type={showPassword1 ? "text" : "password"}
                            variant="outlined"
                            onChange={(e) => setPassword1(e.target.value)}
                            value={password1}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={handleClickShowPassword1}
                                  onMouseDown={handleMouseDownPassword}
                                >
                                  {showPassword1 ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </div>

                        <div className="mt-4 text-center">
                          <InputLabel className="text-muted">
                            Confirm your Password
                          </InputLabel>

                          {/* <Input */}
                          <OutlinedInput
                            type={showPassword2 ? "text" : "password"}
                            onChange={(e) => setPassword2(e.target.value)}
                            value={password2}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={handleClickShowPassword2}
                                  onMouseDown={handleMouseDownPassword}
                                >
                                  {showPassword2 ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </div>
                        <div>
                          {passwordError1 ? (
                            <Alert color="danger" className="mt-4">
                              {detailedErr}
                              {/* ,
                              {this.props.handleError()} */}
                            </Alert>
                          ) : null}
                          {resetError ? (
                            <Alert color="danger" className="mt-4">
                              {resetError}
                            </Alert>
                          ) : null}
                        </div>
                        <div className="mt-5 text-center">
                          <p>
                            <Button
                              color="primary"
                              className="w-md waves-effect waves-light"
                              onClick={() => handleSubmit()}
                              disabled={!verificationCodeEntered || !submit}
                            >
                              {" "}
                              Reset Password!{" "}
                            </Button>{" "}
                          </p>
                        </div>
                      </div>
                      <div className="mt-5 text-center">
                        <p>
                          Return to{" "}
                          <Link
                            to="/login"
                            className="font-weight-medium text-primary"
                          >
                            {" "}
                            Login Page{" "}
                          </Link>{" "}
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col lg={7}>
            <div className="authentication-bg">
              {/* bg-overlay */}
              <div className=""></div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
};

export default PasswordResetPage;